import React from "react";
import classNames from "classnames";

import DatePickerInput from "components/datePickerInput/DatePickerInput";
import { getPortalDatePickerProps } from "helpers/portalDateControls";

import "./teesheet.scss";

interface IPortalDatePickerInputProps {
  windowWidth: number;
  dateBarMinWidth?: number;
  fullLayout?: boolean;
  startingDate: Date;
  setStartingDate: (date: Date) => void;
  disablePastDays?: boolean;
}

export default function PortalDatePickerInput(props: IPortalDatePickerInputProps) {
  const { windowWidth, dateBarMinWidth, fullLayout, startingDate, setStartingDate, disablePastDays } = props;
  const datePickerMode = getPortalDatePickerProps(windowWidth, dateBarMinWidth, fullLayout);

  return (
    <div
      className={classNames("portal-date-picker-input", {
        "portal-date-picker-input--icon-only": datePickerMode.iconOnlyTrigger,
      })}
    >
      <DatePickerInput
        months={1}
        position={datePickerMode.position}
        centeredInputText={datePickerMode.centeredInputText}
        iconOnlyTrigger={datePickerMode.iconOnlyTrigger}
        startingDate={startingDate}
        setStartingDate={setStartingDate}
        disablePastDays={disablePastDays}
      />
    </div>
  );
}
